export const CREATE_ORGANIZATION = 'organization.CREATE_ORGANIZATION';
export const CREATE_ORGANIZATION_SUCCESS = 'organization.CREATE_ORGANIZATION_SUCCESS';
export const CREATE_ORGANIZATION_FAILURE = 'organization.CREATE_ORGANIZATION_FAILURE';
export const UPDATE_ORGANIZATION = 'organization.UPDATE_ORGANIZATION';
export const UPDATE_ORGANIZATION_SUCCESS = 'organization.UPDATE_ORGANIZATION_SUCCESS';
export const UPDATE_ORGANIZATION_FAILURE = 'organization.UPDATE_ORGANIZATION_FAILURE';
export const DELETE_ORGANIZATION = 'organization.DELETE_ORGANIZATION';
export const DELETE_ORGANIZATION_SUCCESS = 'organization.DELETE_ORGANIZATION_SUCCESS';
export const DELETE_ORGANIZATION_FAILURE = 'organization.DELETE_ORGANIZATION_FAILURE';
export const LIST_ORGANIZATIONS = 'organization.LIST_ORGANIZATIONS';
export const LIST_ORGANIZATIONS_SUCCESS = 'organization.LIST_ORGANIZATIONS_SUCCESS';
export const LIST_ORGANIZATIONS_FAILURE = 'organization.LIST_ORGANIZATIONS_FAILURE';
export const OPEN_DELETE_DIALOG = 'organization.OPEN_DELETE_DIALOG';
export const OPEN_UPDATE_DIALOG = 'organization.OPEN_UPDATE_DIALOG';
export const OPEN_CREATE_DIALOG = 'organization.OPEN_CREATE_DIALOG';
export const CLOSE_DIALOGS = 'organization.CLOSE_DIALOGS';